import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
let $ = require('jquery');
const _ = require('lodash');
import { VcaAlertsService } from '../../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'edit-manage-uplink',
  styles: [require('../../../direct-connect.scss')],
  template: require('./edit-manage-uplink.html'),
    providers: [
    Service, TranslateService
  ]
})

export class EditManageUplink {
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Input() createData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() uplinks: Object;
  @Input() stepId: number;
  @Input() stepData: any;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();
  private isTranslationready: boolean = true;
  private isPublicNWSelected: boolean = true;
  private isPlcNWSelected: boolean = true;
  private dataModel = {
    uplinks: [],
    uplinksSelection: [],
    stepId: -1,
    isStepValid: true
  };

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private alert: VcaAlertsService) {
      translate.use(GlobalVariables.LOCALE);
   }

  ngOnChanges(changes) {
      if (this.uplinks) {
          this.dataModel.uplinks = this.uplinks['gatewayInterfaces'];
          this.dataModel.uplinksSelection = [];
          for (let i = 0; i < this.dataModel.uplinks.length; i++) {
            this.dataModel.uplinksSelection.push (
              {
                id: this.dataModel.uplinks[i].networkId,
                selected: true,
                networkName: this.dataModel.uplinks[i].networkName
              }
            );
          }
          this.emitData();
      }
      if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
      }
  }

  onCheckboxChange(event) {
      let totalNWSelected: number = 0;
      for (let i = 0; i < this.dataModel.uplinksSelection.length; i++) {
          if (this.dataModel.uplinksSelection[i].id === event.target.value) {
              this.dataModel.uplinksSelection[i].selected = event.target.checked;
              let networkName: string = this.dataModel.uplinksSelection[i].networkName.toLocaleLowerCase();
              if(!event.target.checked && !(_.startsWith(networkName, 'plc_')) && !(_.startsWith(networkName, 'xaas_'))) {
                  this.isPublicNWSelected = false;
              }
          }
          if (this.dataModel.uplinksSelection[i].selected) {
              totalNWSelected++;
          }
      }
      if (event.target.checked) {
          this.isPublicNWSelected = true;
      }

      this.isPlcNWSelected = (totalNWSelected === 0) ? false : true;
      this.dataModel.isStepValid = this.isPlcNWSelected;
      this.emitData()
  }

  emitData() {
      this.stepEventEmitter.emit(this.dataModel);
  }
  getDisconnectPublicNetworkMsg() {
       return this.translate.instant('directConnect.wizard.disconnectPublicNetworkMsg');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/edit-gateway/steps/edit-manage-uplink.component.ts